var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
define(["require", "exports", "./api", "monaco-editor/esm/vs/editor/editor.api", "./typings"], function (require, exports, api_1, monaco, typings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.api = exports.LANGUAGE_ID = void 0;
    monaco = __importStar(monaco);
    __exportStar(typings_1, exports);
    exports.LANGUAGE_ID = 'graphqlDev';
    monaco.languages.register({
        id: exports.LANGUAGE_ID,
        extensions: ['.graphql', '.gql'],
        aliases: ['graphql'],
        mimetypes: ['application/graphql', 'text/graphql'],
    });
    exports.api = new api_1.LanguageServiceAPI({
        languageId: exports.LANGUAGE_ID,
        schemaConfig: api_1.schemaDefault,
        formattingOptions: api_1.formattingDefaults,
        modeConfiguration: api_1.modeConfigurationDefault,
    });
    monaco.languages.onLanguage(exports.LANGUAGE_ID, () => __awaiter(void 0, void 0, void 0, function* () {
        const graphqlMode = yield getMode();
        graphqlMode.setupMode(exports.api);
    }));
    function getMode() {
        return new Promise((resolve_1, reject_1) => { require(['./graphqlMode'], resolve_1, reject_1); }).then(__importStar);
    }
});
//# sourceMappingURL=monaco.contribution.js.map